<template>
  <div>
    <popup-add-product
      v-if="order"
      ref="popupAddProduct"
      @productSelected="productSelected"
      :existingProducts="order.orderLines"
      :venueOrderLines="venueOrderLines"
    />

    <popup-order-preview
      v-if="order"
      ref="popupOrderPreview"
      @onOrderPlaced="onOrderPlaced"
    />

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div class="mt-6 flex items-center justify-between px-6" v-if="order">
        <div class="flex items-center">
          <img width="40" :src="OrderIcon" class="mr-4" />
          <div>
            <h4>Order</h4>
            <!-- <small>{{ order.id }}</small> -->
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Status</span>
            </div>
            <div v-if="orgOrder.status">
              <vs-chip :color="stateMapping[orgOrder.status].color">
                {{ orgOrder.status }}
              </vs-chip>
            </div>
          </div>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Created by</span>
            </div>
            <div>
              <code
                >{{ orgOrder.createdBy.username }} at
                {{ orgOrder.createdAt | formatDate }}</code
              >
            </div>
          </div>

          <div class="flex flex-col mb-3" v-if="orgOrder.updatedBy">
            <div class="mb-1 text-sm">
              <span>Updated by</span>
            </div>
            <div>
              <code
                >{{ orgOrder.updatedBy.username }} at
                {{ orgOrder.updatedAt | formatDate }}</code
              >
            </div>
          </div>

          <div class="flex flex-col mb-3" v-if="orgOrder.activatedBy">
            <div class="mb-1 text-sm">
              <span>Activated by</span>
            </div>
            <div>
              <code
                >{{ orgOrder.activatedBy.username }} at
                {{ orgOrder.activatedAt | formatDate }}</code
              >
            </div>
          </div>

          <div class="flex flex-col mb-3" v-if="orgOrder.cancelledBy">
            <div class="mb-1 text-sm">
              <span>Cancelled by</span>
            </div>
            <div>
              <code
                >{{ orgOrder.cancelledBy.username }} at
                {{ orgOrder.cancelledAt | formatDate }}</code
              >
            </div>
          </div>

          <p class="mt-5 mb-3" style="font-weight: bold">Order lines</p>

          <div class="flex flex-col mb-3">
            <div>
              <vs-table
                :data="order.orderLines"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <vs-th> Name </vs-th>
                  <vs-th> Cases </vs-th>
                  <vs-th> Price </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="tr.id"
                    v-for="tr in data"
                    :state="tr.orderCases == 0 ? 'danger' : ''"
                  >
                    <vs-td>
                      <span class="text-muted"> {{ tr.stockProductName }}</span>
                    </vs-td>

                    <vs-td>
                      <div v-if="isEditable" class="flex items-center">
                        <vs-input
                          v-model="tr.orderCases"
                          type="number"
                          :min="0"
                          style="max-width: 4.5rem"
                        />
                      </div>
                      <div v-else>
                        <span>{{ tr.orderCases }}</span>
                      </div>
                      <vx-tooltip
                        v-if="isEditable"
                        text="The number of units that will be in stock (compared to the desired amount) if ordering the number of cases specified above."
                        position="top"
                      >
                        <div>
                          <div class="whitespace-no-wrap">
                            {{
                              tr.orderCases * tr.caseSize + tr.venueStockAmount
                            }}
                            /
                            {{ tr.venueDesiredStockAmount }}
                          </div>
                        </div>
                      </vx-tooltip>
                    </vs-td>

                    <vs-td>
                      <span>{{
                        parseFloat(
                          tr.orderCases * tr.caseSize * tr.unitPrice
                        ).toFixed(2)
                      }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        v-if="isEditable"
                        @click="removeProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  v-if="isEditable"
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddProduct.show()"
                >
                  Add order line
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-4" @click="save" :disabled="!isFormValid">
          Save
        </vs-button>
        <vs-button class="mr-4" @click="onClickPreview"> Preview </vs-button>
        <vs-button color="danger" v-if="isDeleteable" @click="confirmDelete">
          Delete
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import OrderIcon from "@/assets/images/order-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddProduct.vue";
import PopupOrderPreview from "./PopupOrderPreview.vue";

export default {
  components: {
    VuePerfectScrollbar,
    PopupAddProduct,
    PopupOrderPreview,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      OrderIcon,

      isActive: false,
      isLoading: true,

      order: null,
      orgOrder: null,
    };
  },
  computed: {
    ...mapGetters({
      venueOrderLines: "pimVenues/venueOrderLines",
      activeVenueId: "venues/activeVenueId",
      stateMapping: "orders/stateMapping",
    }),

    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isEditable() {
      return this.orgOrder && this.orgOrder.status === "Draft";
    },
    isDeleteable() {
      return (
        this.orgOrder &&
        (this.orgOrder.status === "Draft" || this.orgOrder.status === "Active")
      );
    },
  },
  methods: {
    async onClickPreview() {
      if (this.isEditable) {
        await this.save();
      }
      this.$refs.popupOrderPreview.show(this.order);
    },
    onOrderPlaced() {
      this.isActive = false;
    },
    removeProduct(id) {
      this.order.orderLines = this.order.orderLines.filter(
        (x) => x.stockProductId.id !== id
      );
    },
    productSelected(orderLine) {
      // Don't add if already exists
      if (
        this.order.orderLines.find(
          (x) => x.stockProductId.id === orderLine.stockProductId.id
        )
      ) {
        return;
      }

      this.order.orderLines.push(orderLine);
    },
    async showOrder(orderId) {
      this.isActive = true;
      this.isLoading = true;

      var result = await this.$store.dispatch("orders/getOrder", orderId);

      this.orgOrder = result;
      this.order = result;

      await this.loadExternalData();
      console.log("Got order", this.order);
      this.isLoading = false;
    },
    async loadExternalData() {
      await this.$store.dispatch(
        "pimVenues/getVenueOrderLines",
        this.activeVenueId
      );
      console.log("Total venue order lines", this.venueOrderLines);
    },
    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Are you sure you want to cancel this order? It will still be visible, but will be marked as cancelled.`,
        accept: async () => {
          try {
            console.log("Deleting order", this.orgOrder, this.activeVenueId);
            await this.$store.dispatch("orders/cancelOrder", this.orgOrder.id);
            await this.$store.dispatch(
              "orders/getOrders",
              this.orgOrder.venueId.id
            );

            this.$vs.notify({
              title: "Order cancelled",
              text: "Your order has been cancelled.",
            });

            this.isActive = false;
            this.order = null;
            this.orgOrder = null;
            this.isLoading = true;
          } catch (err) {
            this.$vs.notify({
              title: "Error",
              text: `Failed to cancel order: ${err}`,
            });
            console.error(err);
          }
        },
      });
    },
    async save() {
      console.log("Saving DTO", this.order);

      this.order.id = this.orgOrder.id;

      try {
        const result = await this.$store.dispatch("orders/updateOrder", {
          orderId: this.orgOrder.id,
          dto: {
            orderLines: this.order.orderLines.map((item) => ({
              stockProductId: item.stockProductId.id,
              orderCases: item.orderCases,
            })),
          },
        });
        await this.$store.dispatch(
          "orders/getOrders",
          this.orgOrder.venueId.id
        );

        await this.showOrder(this.orgOrder.id); // Refresh order line totals for this view

        this.$vs.notify({
          title: "Order saved",
          text: "Your order has been saved.",
        });
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to save order: ${err}`,
        });
      }
    },
    async create() {
      console.log("Creating DTO", this.order);

      const result = await this.$store.dispatch(
        "orders/createOrder",
        this.order
      );

      await new Promise((resolve) => setTimeout(resolve, 1500)); // FIXME - Wait for backend to update

      if (result) {
        this.$vs.notify({
          title: "Order created",
          text: "Your order has been created.",
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Failed to create order.",
        });
      }

      this.order = null;
      this.orgOrder = null;
      this.isActive = false;
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>